<template>
  <div class="h-100">
    <div class="vue-datatables">
      <!-- Statuses filters -->
      <div class="row mb-3 flex-wrap"  >
        <div class="col-auto mb-2" v-for="status in statuses" v-if="status.count">
          <div class="bg-white p-1 rounded shadow cursor-pointer d-flex justify-content-between align-items-center"
               :class="{'border' : status_id == status.key,[status.key]:true}"
               :style="{'border-color' : status_id == status.key ? status.color + '!important' : ''}"
               @click="status_id = status.key; filterInsuranceCompany(status_id);">
            <span class="text-capitalize">{{ status.value }} ({{ status.count }})</span>
          </div>
          <div v-if="status_id != status.key" class="border-bottom-3 mt-1" :style="{'color' : status.color }"></div>
        </div>

      </div>
      <div>
        <!-- Clean Filter Button-->
        <button @click="filterInsuranceCompany('all')" class="btn border btn-sm mb-2">{{$t('message.cleanFilter')}}</button>
      </div>

      <loader v-if="inProgress"/>
      <v-client-table :data="rows" :columns="columns" :options="options" @pagination="closeRowEdit"
                      @sorted="closeRowEdit"
                      ref="table" v-show="!dataTableReady">

        <!-- This handle the header translate -->
        <template v-for="(item, k) in columns" :slot="'h__' + item">
          <span>{{ $t('tables.headers.' + item) }}</span>
          <input v-if="k === 0 " type="checkbox"  name="selectAll" v-model="rolesSelected" class="align-self-center" @click='selectAll($event)' />
        </template>



        <!-- ROW ACTIONS -->
        <template v-slot:actions="props">
          <div class="d-flex justify-content-around h-100">
            <RowActions
              :route="$route"
              :id="'preview-order-list'+'_'+props.row.id"
              :value="props.row.id.toString()"
              @catchPreviewList="catchPreviewList"
              :phoneNumber="props.row['phone'].toString()"
            />
            <router-link :to="`view?table=calculator&id=${props.row.id}`" target="_blank">
              <span class="icon icon-doublearrowleft"></span>
            </router-link>
          </div>
        </template>

      </v-client-table>

    </div>
  </div>
</template>

<script>
import axios from '../axios'
import config from '../table-config';
import DataTable from "@/mixins/DataTable";
import FormControl from "@/components/formcontrol";
import Auth from "@/mixins/Auth";
import Excel from "@/mixins/Excel";
import TypeFilter from "@/components/TypeFilter";
import {isEqual, pickBy} from "lodash";
import loader from '@/components/loader'
import RowActions from "@/components/rowActions.vue";



export default {
  name: "CalculatorView",
  components: {RowActions, TypeFilter, FormControl, loader},
  mixins: [DataTable, Auth, Excel],

  async mounted () {
    this.dataTableReady = true;
    this.appendData()

    let displayCols = localStorage.getItem(`table_${this.$route.name}_settings`);
    if (displayCols) {
      let displayColsToArr = _.split(displayCols, ',')
      this.$refs.table.userControlsColumns = true
      this.$refs.table.userColumnsDisplay = displayColsToArr
    } else if (this.tconfig.initDisplayCols) {
      this.$refs.table.userControlsColumns = false
      this.$refs.table.userColumnsDisplay = this.tconfig.initDisplayCols
    }
  },
  data() {
    return {
      types: [],
      rows: [],
      columns: [],
      url_params: '',
      selectedCustomFilter: null,
      tconfig: config.calculator,
      inProgress: true,
      openStatusCampaign: false,
      dataTableReady: false,
      config: {
        schema: config.calculator.schema,
        initDisplayCols: config.calculator.initDisplayCols
      },
      statuses: [],
      previewOrderList: [],
      campaignMessages: [],
      rolesSelected: '',
      campaignKind: '',
      options: {
        perPageValues: [
          25,
          50,
          100,
        ],
        perPage: 50,
        initFilters: {
          GENERIC: this.$route.query.query ?this.$route.query.query:"",
          ...pickBy(this.$route.query)
        },
        orderBy: {
          ascending: this.$route.query.tsortcolumn ? this.getBool(this.$route.query.tsortcolumn.split(',')[0]) : '',
          column: this.$route.query.tsortcolumn ? this.$route.query.tsortcolumn.split(',')[1] : ''
        },

        filterable: true,
        dateColumns: [],
        columnsDropdown: this.$store.getters.isAdmin || this.$store.getters.isManagement || '',
        texts: {
          count: `${this.$t('tables.general.display')} {from} ${this.$t('tables.general.to')} {to} ${this.$t('tables.general.of')} {count} ${this.$t('tables.general.records')}|{count} ${this.$t('tables.general.records')}|${this.$t('tables.general.oneRecord')}`,
          // first: 'First',
          // last: 'Last',
          filter: '',
          filterPlaceholder: this.$t('tables.general.searchQuery'),
          limit: this.$t('tables.general.records'),
          limitPlaceholder: this.$t('tables.general.records'),
          page: this.$t('tables.general.page'),
          noResults: this.$t('tables.general.noMatchingRecords'),
          filterBy: `${this.$t('tables.general.filterBy')} {column}`,
          loading: this.$t('tables.general.loading'),
          defaultOption: `${this.$t('tables.general.select')} {column}`,
          columns: this.$t('tables.general.columns')
        },
        sortable: _.without(this.tcols, 'actions', 'select'),
        sortIcon: {
          base: 'fontawesome',
          up: 'fa fa-chevron-up',
          down: 'fa fa-chevron-down',
          is: 'fa fa-sort'
        },
        customFilters: [
          "phone", "statusId", "date"
        ],
      }
    }
  },

  computed: {
    columns() {
      return this.config.schema.map(r => r.name);
    }
  },
  methods: {
    appendData() {
      let that = this;
      axios.get(`/calculator/all`).then((res) => {
        this.dataTableReady = false;
        this.onLoading(false)


        if(res.data.data.rows) {
          this.inProgress = false;
          const resData = res.data.data.rows

          let resKeys
          if (!_.isObject(resData[0])) {
            resKeys = resData
          } else {
            resKeys = Object.keys(resData[0])
          }


          // resKeys.unshift('#')
          if (!this.config.readonly) {
            resKeys.unshift('actions')
          }
          resKeys = _.without(resKeys, 'userId', 'updated_at')

          this.rows = resData;
          this.columns = that.config.initDisplayCols
          this.setStatuses(res.data.data.options.calculator);
        }
      })

    },
    onLoading(inProgress) {
      this.inProgress = inProgress
    },

    catchPreviewList(mobilePhoneNumber) {
      let tmp = [];
      $("input[name='preview-order-list']").each(function () {
        if ($(this).is(':checked')) {
          let checked = {
            "id": ($(this).val()),
            "mobilePhone": mobilePhoneNumber
          };
          tmp.push(checked);
        }
      });
      this.previewOrderList = tmp;
    },
    setStatuses(statuses) {
      let arr = [];
      for (let i in statuses) {
        if (statuses[i].statusGroup === this.tconfig.statusGroup || statuses[i].statusGroup === 0) {
          arr.push(statuses[i])
        }
      }
      this.statuses = arr;
    },
    filterInsuranceCompany(id) {
      let data = this.$route.query;
      data.id = id;
      if(!data.pages_chunk || parseInt(data.pages_chunk) === 0){
        data.pages_chunk = '25';
      }

      let url_page = '';
      if(data.page){
        url_page = "/" + data.page;
      }else{
        url_page = "/1";
      }

      let statusId = id
      this.$router.push({query: {statusId}});

      this.dataTableReady = true;
      axios.post(`/calculator/calculatorFilter`, data)
        .then((res) => {
          if (res.data.data.rows) {
            this.dataTableReady = false;
            const resData = res.data.data.rows

            let resKeys
            if (!_.isObject(resData[0])) {
              resKeys = resData
            } else {
              resKeys = Object.keys(resData[0])
            }


            // resKeys.unshift('#')
            if (!this.config.readonly) {
              resKeys.unshift('actions')
            }
            resKeys = _.without(resKeys, 'userId', 'updated_at')

            this.rows = resData;

          } else {
            this.$parent.$emit('alert', 'danger', 'No rows found')
          }
        })
        .catch((err) => {
          this.dataTableReady = false;
          this.$parent.$emit('alert', 'danger', err.response.data.data.error)
        })
    },
  },



}
</script>

<style scoped>

</style>
